import {
  PlannerConfigEntityPhraseStrings,
  PlannerConfigEntityWithOptionalFields,
} from '@/services/configurator/PlannerConfigTypes';
import { Control, FieldPath, UseFormReturn } from 'react-hook-form';
import { ToggleablePhraseFields } from './ToggleablePhraseFields';
import {
  CategorizedPhraseKey,
  getPhraseCategory,
} from '@/config/phrase-contract';
import { renderPreviewComponent } from '@/utils/previewComponentMap';

export type PreviewableToggleablePhraseFieldsProps = {
  sectionKey: FieldPath<PlannerConfigEntityWithOptionalFields>;
  phraseKey: CategorizedPhraseKey;
  watchedPhraseStrings: PlannerConfigEntityPhraseStrings;
  watchedPlanner: PlannerConfigEntityWithOptionalFields;
  formControl: Control<PlannerConfigEntityWithOptionalFields>;
  phraseForm: UseFormReturn<PlannerConfigEntityWithOptionalFields>;
  disableFields?: boolean;
  className?: string;
  syncedPhraseKeys?: Set<string>;
};

export function PreviewableToggleablePhraseFields({
  sectionKey,
  phraseKey,
  watchedPhraseStrings,
  watchedPlanner,
  formControl,
  phraseForm,
  disableFields,
  className,
  syncedPhraseKeys,
}: PreviewableToggleablePhraseFieldsProps) {
  const phraseCategory = getPhraseCategory({ component: phraseKey });

  return (
    <div className={`mt-8 flex flex-row gap-8 ${className ?? ''}`}>
      <ToggleablePhraseFields
        formControl={formControl}
        phraseForm={phraseForm}
        sectionKey={sectionKey}
        sectionTitle={phraseCategory.text}
        sectionDescription={phraseCategory.description ?? ''}
        phraseStringKeys={phraseCategory.phraseKeys}
        disableFields={disableFields}
        sectionClassName='w-1/2'
        syncedPhraseKeys={syncedPhraseKeys}
      />
      {renderPreviewComponent(
        phraseKey,
        watchedPhraseStrings ?? {},
        watchedPlanner,
        watchedPlanner.contentPageSectionVisibility,
        watchedPlanner.contentPageVariant,
      )}
    </div>
  );
}
